export class Enfant {
  nombreEnfants: number = 0;
  dateNaissanceEnfant: string[] = [];

  constructor(nombreEnfants: number, dateNaissanceEnfant: string[]) {
    this.nombreEnfants = nombreEnfants;
    this.dateNaissanceEnfant = dateNaissanceEnfant;
  }
}
